<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware />

    <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">
        <div class="breadcrumb_box text-center">
          <h2 class="breadcrumb-title">{{$t('ik')}}</h2>
          <!-- breadcrumb-list start -->
          <ul class="breadcrumb-list">
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{$t('home')}}</router-link>
            </li>
            <li class="breadcrumb-item active">{{$t('ik')}}</li>
          </ul>
          <!-- breadcrumb-list end -->
        </div>
      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->

    <!-- accordion section start -->
    <div class="accordion-wrapper section-space--pb_90">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="faq-wrapper section-space--pt_90">
              <div class="section-elements-title mb-30">
                <h4>Açık Pozisyonlar</h4>
                <p>Yazılım sektörünün öncülerinden Barkod Yazılım, Araştırma/Geliştirme'den Ürün Danışmanlığı'na, Satış/Pazarlama'dan Satış Sonrası Hizmetler'e, Mali İşler'den İnsan Kaynakları'na tüm iş süreçlerinde mükemmelliği ve koşulsuz müşteri memnuniyetini hedefleyen adayları, Barkod Yazılım'ın gelişmeye açık, çağdaş ve saygın ortamına davet ediyor.</p>
                <p>Barkod Yazılımı İstanbul ve Üretim AR-GE'de nitelikli ve deneyimli çalışanlardan oluşan kadrosunu yeni elemanlarla güçlendirmektedir. Hedefi çok daha büyük yazılım projelerine imza atmak olan Barkod Yazılım'da bu hedefi paylaşacak, dinamik, sorumluluk ve vizyon sahibi takım arkadaşlarına her zaman yer vardır.</p>
                <p>İnsana ve bilgiye önem vermek, ayrımcılık yapmamak, performansa dayalı gelişim, yetki ve sorumluluk paylaşımı, objektif performans değerlendirme Barkod Yazılım İnsan Kaynakları politikasının temel ilkeleridir. İşe alımlarda fırsat eşitliği ilkesi gözetilir, değerlendirmeler bilgi ve deneyime göre yapılır. Başarı, şirket amaçlarına uygun üretimle değerlendirilir. Bu yaklaşım uzun süreli çalışma oranının sektör ortalamalarına göre çok yüksek olmasını, dolayısıyla beyin gücünün temel olduğu yazılım sektöründe Barkod Yazılım'ın uzun vadede rekabet gücünü en üst düzeye çıkartmasını sağlamaktadır.</p>
                <p>Tüm Barkod Yazılım çalışnanları, iş sonuçları ve yetkinliklerinin ölçülmesi, izlenmesi ve geliştirilmesine dayanan, şirket içi bütün grupların birbirini değerlendirmesine imkan veren, bir performans değerlendirme sistemi ile değerlendirilmektedir.</p>
                <p>Üretilen iş sonuçlarının Barkod Yazılım'ın temel hedefleri ile ilişkisi izlenerek, yapılan işlerin sağladığı katma değer ölçülmekte ve böylece verimlilik arttırılmaktadır. Performans Değerlendirme Sistemi Barkod Yazılım'ın genel ölçüm sisteminin bir parçasıdır. Değerlendirme sonuçlarına göre Barkod Yazılım çalışanlarının elde edeceği ödüller de belirlidir.</p>
              </div>
              <!-- accordion component -->
              <!-- <Accordion /> -->
              <div class="accordion-faq wow move-up">
                <b-card no-body>
                  <b-card-header header-tag="header">
                    <b-button
                      block
                      v-b-toggle.accordion-1
                      class="faq-title"
                    >{{ $t('Yazılım Mühendisi') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-1" visible accordion="my-accordion">
                    <b-card-body>
                      <b-card-text>
                        <ul class="check-list green-check-list section-space--mb_50">
                          <li>
                            <i class="list-item"></i>ODTÜ, Bilkent, Hacettepe veya eşdeğer özelliklerde eğitim veren üniversitelerin Bilgisayar Mühendisliği Bölümlerinden mezun,
                          </li>
                          <li>
                            <i class="list-item"></i>İyi derecede asgari 2 yazılım dili bilgisine sahip (C++,Java,VB, C# tercih edilir.),
                          </li>
                          <li>
                            <i class="list-item"></i>İlişkisel Veritabanı Yönetim Sistemleri ile uygulama geliştirimiş (IBM DB2,MS-SQL ve Oracle tercih edilir.),
                          </li>
                          <li>
                            <i class="list-item"></i>En az 2 yıl deneyimli,
                          </li>
                          <li>
                            <i class="list-item"></i>Erkek adayların askerlik görevini tamamlamış veya en az 2 yıl tecil ettirmiş olmaları zorunludur.
                          </li>
                          <li>
                            <i class="list-item"></i>Takım Oyuncusu
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body>
                  <b-card-header header-tag="header">
                    <b-button
                      block
                      v-b-toggle.accordion-2
                      class="faq-title"
                    >{{ $t('Satış Temsilcisi') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-2" visible accordion="my-accordion">
                    <b-card-body>
                      <b-card-text>
                        <ul class="check-list green-check-list section-space--mb_50">
                          <li>
                            <i class="list-item"></i>Üniversite Mezunu (Endüstri Mühendisliği, İşletme ve Ekonomi mezunları tercih edilir.),
                          </li>
                          <li>
                            <i class="list-item"></i>En az 3 yıl aktif satış deneyimine sahip,
                          </li>
                          <li>
                            <i class="list-item"></i>Seyahat engeli olmayan,
                          </li>
                          <li>
                            <i class="list-item"></i>İyi derecede İngilizce dili bilgisi tercih edilir
                          </li>
                          <li>
                            <i class="list-item"></i>Uygulama Yazılımları (Kurumsal Kaynak Planlama, Yönetim Bilgi Sistemleri, Ticari Yazılımlar) deneyimine sahip olmak
                          </li>
                          <li>
                            <i class="list-item"></i>Erkek adayların askerlik görevini tamamlamış veya en az 2 yıl tecil ettirmiş olmaları zorunludur.
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body>
                  <b-card-header header-tag="header">
                    <b-button
                      block
                      v-b-toggle.accordion-3
                      class="faq-title"
                    >{{ $t('Kanal Satış Sorumlusu') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-3" visible accordion="my-accordion">
                    <b-card-body>
                      <b-card-text>
                        <ul class="check-list green-check-list section-space--mb_50">
                          <li>
                            <i class="list-item"></i>Üniversite Mezunu (Endüstri Mühendisliği, İşletme ve Ekonomi mezunları tercih edilir.),
                          </li>
                          <li>
                            <i class="list-item"></i>En az 3 yıl aktif satış deneyimine sahip,
                          </li>
                          <li>
                            <i class="list-item"></i>Seyahat engeli olmayan,
                          </li>
                          <li>
                            <i class="list-item"></i>İyi derecede İngilizce dili bilgisi tercih edilir
                          </li>
                          <li>
                            <i class="list-item"></i>Uygulama Yazılımları (Kurumsal Kaynak Planlama, Yönetim Bilgi Sistemleri, Ticari Yazılımlar) deneyimine sahip olmak
                          </li>
                          <li>
                            <i class="list-item"></i>Erkek adayların askerlik görevini tamamlamış veya en az 2 yıl tecil ettirmiş olmaları zorunludur.
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body>
                  <b-card-header header-tag="header">
                    <b-button
                      block
                      v-b-toggle.accordion-4
                      class="faq-title"
                    >{{ $t('Ürün Danışmanı') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-4" visible accordion="my-accordion">
                    <b-card-body>
                      <b-card-text>
                        <ul class="check-list green-check-list section-space--mb_50">
                          <li>
                            <i class="list-item"></i>Analitik düşünme, organizasyon ve iletişim becerileri gelişmiş,
                          </li>
                          <li>
                            <i class="list-item"></i>Girişken, dinamik ve takım çalışmasına yatkın,
                          </li>
                          <li>
                            <i class="list-item"></i>ODTÜ, Bilkent, Boğaziçi veya eşdeğer özelliklerde eğitim veren üniversitelerin Endüstri Mühendisliği bölümlerinden mezun,
                          </li>
                          <li>
                            <i class="list-item"></i>Kurumsal Kaynak Planlama (ERP) ve İş Süreçleri Yönetimi (BPM) bilgisine sahip,
                          </li>
                          <li>
                            <i class="list-item"></i>İlişkisel Veritabanı Yönetim Sistemleri ile raporlama araçları deneyimine sahip,
                          </li>
                          <li>
                            <i class="list-item"></i>Erkek adayların askerlik görevini tamamlamış veya en az 2 yıl tecil ettirmiş olmaları zorunludur.
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body>
                  <b-card-header header-tag="header">
                    <b-button
                      block
                      v-b-toggle.accordion-5
                      class="faq-title"
                    >{{ $t('Eğitim Destek Sorumlusu') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-5" visible accordion="my-accordion">
                    <b-card-body>
                      <b-card-text>
                        <ul class="check-list green-check-list section-space--mb_50">
                          <li>
                            <i class="list-item"></i>Üniversite Mezunu (Endüstri Mühendisliği, İşletme ve Ekonomi mezunları tercih edilir.),
                          </li>
                          <li>
                            <i class="list-item"></i>En az 3 yıl Yazılım Eğitim/Destek deneyimine sahip,
                          </li>
                          <li>
                            <i class="list-item"></i>Uygulama Yazılımları (Kurumsal Kaynak Planlama, Yönetim Bilgi Sistemleri ve Ticari Yazılımlar) deneyimine sahip olmak,
                          </li>
                          <li>
                            <i class="list-item"></i>Erkek adayların askerlik görevini tamamlamış veya en az 2 yıl tecil ettirmiş olmaları zorunludur.
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="faq-wrapper section-space--pt_90">
              <div class="section-elements-title mb-30">
                <h4>Başvuru Yap</h4>
                <span>48 Saat içerisinde geri dönüş yapacağız</span>
              </div>
              <!-- Toggle component -->
              <!-- <AccordionToggle /> -->
              <div class="contact-from-wrapper wow move-up">
                <!-- <div class="contact-form-result"></div> -->

                <form v-on:submit="gonderMail"  >
                  <!-- <div class="form-process"></div> -->
                  <div class="contact-page-form">
                    <div class="contact-inner">
                      <input
                        type="text"
                        id="template-jobform-fname"
                        name="template-jobform-fname"
                        v-model="ContactForm.sAdi"
                        value
                        class="sm-form-control required"
                        placeholder="Ad *"
                      />
                    </div>

                    <div class="contact-inner">
                      <input
                        type="text"
                        id="template-jobform-lname"
                        name="template-jobform-lname"
                        v-model="ContactForm.sSoyadi"
                        value
                        class="sm-form-control required"
                        placeholder="Soyad *"
                      />
                    </div>

                    <div class="clear"></div>

                    <div class="contact-inner">
                      <input
                        type="email"
                        id="template-jobform-email"
                        name="template-jobform-email"
                        v-model="ContactForm.sMail"
                        value
                        class="required email sm-form-control"
                        placeholder="Email *"
                      />
                    </div>

                    
                    <div class="contact-inner">
                      <input
                        type="tel"
                        name="template-jobform-phone"
                        v-model="ContactForm.sTelefon"
                        id="template-jobfor-phone"
                        value
                        size="22"
                        tabindex="4"
                        class="sm-form-control required"
                        placeholder="Telefon *"
                      />
                    </div>

                    <div class="contact-inner">
                      <input
                        type="text"
                        name="template-jobform-age"
                        v-model="ContactForm.sYas"
                        id="template-jobform-age"
                        value
                        size="22"
                        tabindex="4"
                        class="sm-form-control required"
                        placeholder="Yaş *"
                      />
                    </div>

                    <div class="contact-inner">
                      <input
                        type="text"
                        name="template-jobform-city"
                        v-model="ContactForm.sSehir"
                        id="template-jobform-city"
                        value
                        size="22"
                        tabindex="5"
                        class="sm-form-control required"
                        placeholder="Şehir *"
                      />
                    </div>

                    <div class="clear"></div>

                    <div class="contact-inner">
                      <select
                        name="template-jobform-position"
                        v-model="ContactForm.sPozisyon"
                        id="template-jobform-position"
                        tabindex="9"
                        class="sm-form-control required"
                      >
                        <option value>-- Select Position --</option>
                        <option value="Yazılım Muhendisi">Yazılım Mühendisi</option>
                        <option value="Satis Temsilcisi">Satış Temsilcisi</option>
                        <option value="Kanal Satis Sorumlusu">Kanal Satış Sorumlusu</option>
                        <option value="Urun Danismani">Ürün Danışmanı</option>
                        <option value="Egitim Destek Sorumlusu">Eğitim Destek Sorumlusu</option>
                      </select>
                    </div>

                    <div class="contact-inner">
                      <input
                        type="text"
                        name="template-jobform-salary"
                        v-model="ContactForm.sMaas"
                        id="template-jobform-salary"
                        value
                        size="22"
                        tabindex="6"
                        class="sm-form-control"
                        placeholder="Maaş Beklentisi"
                      />
                    </div>

                    <div class="contact-inner">
                      <input
                        type="text"
                        name="template-jobform-start"
                        v-model="ContactForm.dteBaslamaTarihi"
                        id="template-jobform-start"
                        value
                        size="22"
                        tabindex="7"
                        class="sm-form-control"
                        placeholder="Başlama Tarihi"
                      />
                    </div>

                    <div class="clear"></div>

                    <div class="contact-inner">
                      <input
                        type="text"
                        name="template-jobform-website"
                        v-model="ContactForm.sWeb"
                        id="template-jobform-website"
                        value
                        size="22"
                        tabindex="8"
                        class="sm-form-control"
                        placeholder="Web Site (eğer varsa)"
                      />
                    </div>

                    <div class="contact-inner">
                      <textarea
                        name="template-jobform-experience"
                        v-model="ContactForm.sDeneyim"
                        id="template-jobform-experience"
                        rows="3"
                        tabindex="10"
                        class="sm-form-control"
                        placeholder="Deneyimler (optional)"
                      ></textarea>
                    </div>

                    <div class="contact-inner">
                      <textarea
                        name="template-jobform-application"
                        v-model="ContactForm.sUygulamalar"
                        id="template-jobform-application"
                        rows="6"
                        tabindex="11"
                        class="sm-form-control required"
                        placeholder="Uygulamalar *"
                      ></textarea>
                    </div>

                    <div class="contact-inner" hidden>
                      <input
                        type="text"
                        id="template-jobform-botcheck"
                        name="template-jobform-botcheck"
                        value
                        class="sm-form-control"
                      />
                    </div>

                    <div class="contact-inner" enable="false">
                      <button
                        class="button button-3d button-large btn-block nomargin"
                        name="template-jobform-apply"
                        type="submit"
                        value="apply"
                      >Başvuruyu Gönder</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- accordion section end -->

    <!-- footer section -->
    <FooterMain />

    <!-- offcanvas search component -->
    <OffcanvasSearchBox />

    <!-- off-canvas mobile menu -->
    <OffCanvasMobileMenu />
  </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import Breadcrumb from "@/components/Breadcrumb";
import FooterMain from "@/components/FooterMain";
import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu";
import axios from 'axios';
import qs from 'qs';
import xml2js from "xml2js";
import fs from "fs";
import notify from 'devextreme/ui/notify';
import { mapGetters } from "vuex";

export default {
  components: {
    HeaderSoftware,
    Breadcrumb,
    FooterMain,
    OffcanvasSearchBox,
    OffCanvasMobileMenu
  },
  data() {
        return {
            sFirma:'',
            sModuller:'',
            sOnayKodlari:'',
            sent: false,
              ContactForm: {
                sAdi: '',
                sSoyadi: '',
                sMail:'',
                sYas:'',
                sTelefon:'',
                sSehir:'',
                sPozisyon:'',
                sMaas:'',
                dteBaslamaTarihi:'',
                sWeb:'',
                sDeneyim:'',
                sUygulamalar:'',
                phone: '',
                subject: 'ik',
                message: 'İş Başvurusu'
              }
            }
        },
        computed:{
            ...mapGetters("auth", ["getFirmaResult"])
        },    
        methods:{
            gonderMail(){
                //console.log(event);
                //console.log(this.ContactForm);
                //console.log(this);
                //console.log(event);
                //console.log(event.target.childNodes);
                //console.log(event.srcElement.childNodes[1]._value);
                
                event.preventDefault()
                //debugger;
                var str="<?xml version='1.0' encoding='utf-8'?>"+
                      "<soap12:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:soap12='http://www.w3.org/2003/05/soap-envelope'>"+
                      "<soap12:Header>" +
                      "<SecuredTokenWebservice xmlns='http://tempuri.org/'>"+
                      "<sMail>"+this.getFirmaResult.sMail+"</sMail>"+
                      "<sUserName>"+this.getFirmaResult.nFirmaID+"</sUserName>"+
                      "<sPassword>"+this.getFirmaResult.sPostaKodu+"</sPassword>"+
                      "<AuthenticationToken>string</AuthenticationToken>"+
                      "<sBayii>"+this.getFirmaResult.nFirmaID+"</sBayii>"+
                      "</SecuredTokenWebservice>"+
                      "</soap12:Header>"+
                      "<soap12:Body>"+
                      "<AuthenticationUser xmlns='http://tempuri.org/' />"+
                      "</soap12:Body>"+
                      "</soap12:Envelope>";
                      
                      axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',data:str,headers: {'Content-Type': 'text/xml','Access-Control-Allow-Headers': 'Origin'}})
                      .then((response) => {
                        //console.log(response);
                        var parseString = require('xml2js').parseString;
                        var xml = response.data
                        var AuthenticationToken =""
                        parseString(xml, function (err, result) {
                          //console.log(result["soap:Envelope"]["soap:Body"][0].AuthenticationUserResponse[0].AuthenticationUserResult[0]);
                          AuthenticationToken = result["soap:Envelope"]["soap:Body"][0].AuthenticationUserResponse[0].AuthenticationUserResult[0];
                        });
                      var sFirma = "<p><strong><u>" + this.ContactForm.message + ";</u></strong><br>" ; 
                      sFirma +="Ad:<strong>" + this.ContactForm.sAdi  + "</strong><br>";
                      sFirma +="Soyadı:<strong>" + this.ContactForm.sSoyadi + "</strong></p><br>";
                      sFirma +="Mail:<strong>" + this.ContactForm.sMail + "</strong></p><br>";
                      sFirma +="Telefon:<strong>" + this.ContactForm.sTelefon + "</strong></p><br>";
                      sFirma +="Yaş:<strong>" + this.ContactForm.sYas + "</strong></p><br>";
                      sFirma +="Şehir:<strong>" + this.ContactForm.sSehir + "</strong></p><br>";
                      sFirma +="Pozisyon:<strong>" + this.ContactForm.sPozisyon + "</strong></p><br>";
                      sFirma +="Maaş Beklentisi:<strong>" + this.ContactForm.sMaas + "</strong></p><br>";
                      sFirma +="İşe Başlama Tarihi:<strong>" + this.ContactForm.dteBaslamaTarihi + "</strong></p><br>";
                      sFirma +="Web Site:<strong>" + this.ContactForm.sWeb + "</strong></p><br>";
                      sFirma +="Deneyim:<strong>" + this.ContactForm.sDeneyim + "</strong></p><br>";
                      sFirma +="Uygulamalar:<strong>" + this.ContactForm.sUygulamalar + "</strong></p><br>";
                      //console.log(sFirma);
                      var ip=window.location.host; 
                      axios('https://api.ipify.org?format=json')
                        .then(response => {
                            ip=response.data.ip
                            console.log(ip);
                        
                      var str2="<?xml version='1.0' encoding='utf-8'?>"+
                      "<soap12:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:soap12='http://www.w3.org/2003/05/soap-envelope'>"+
                      "<soap12:Header>" +
                      "<SecuredTokenWebservice xmlns='http://tempuri.org/'>"+
                      "<sMail>"+this.getFirmaResult.sMail+"</sMail>"+
                      "<sUserName>"+this.getFirmaResult.nFirmaID+"</sUserName>"+
                      "<sPassword>"+this.getFirmaResult.sPostaKodu+"</sPassword>"+
                      "<AuthenticationToken>"+AuthenticationToken+"</AuthenticationToken>"+
                      "<sBayii>"+this.getFirmaResult.nFirmaID+"</sBayii>"+
                      "</SecuredTokenWebservice>"+
                      "</soap12:Header>"+
                      "<soap12:Body>"+
                      "<mail_gonder xmlns='http://tempuri.org/'>"+
                      "<sSubject>"+this.ContactForm.subject+"</sSubject>"+
                      "<nFirmaID>"+this.getFirmaResult.nFirmaID+"</nFirmaID>"+
                      "<sKodu></sKodu>"+
                      "<sAciklama></sAciklama>"+
                      "<sAdres1></sAdres1>"+
                      "<sAdres2></sAdres2>"+
                      "<sSemt></sSemt>"+
                      "<sIl></sIl>"+
                      "<telefon></telefon>"+
                      "<sEMail>"+this.ContactForm.email+"</sEMail>"+
                      "<sVergiDairesi></sVergiDairesi>"+
                      "<sVergiNo></sVergiNo>"+
                      "<nAlisverisID>0</nAlisverisID>"+
                      "<lFisNo>0</lFisNo>"+
                      "<sFirma><![CDATA["+  sFirma + "]]></sFirma>"+
                      "<sModuller><![CDATA[<strong>"+this.sModuller+"</strong>]]></sModuller>"+
                      "<sOnayKodlari><![CDATA["+this.sOnayKodlari+"]]></sOnayKodlari>"+
                      "<sOdemeSekli>"+this.ContactForm.subject+"</sOdemeSekli>"+
                      "<sIp>"+ip+"</sIp>"+
                      "</mail_gonder>"+
                      "</soap12:Body>"+
                      "</soap12:Envelope>";
                      
                      //console.log(str2);
                      axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',data:str2,headers: {'Content-Type': 'text/xml; charset=utf-8','Access-Control-Allow-Headers': 'Origin'}})
                      .then((response) => {
                          if (response.status==200){
                            console.log(response.statusText);
                            notify(this.$t('thanks'), "info", 5000);
                            this.sent=true;
                            this.ContactForm.sAdi='';
                            this.ContactForm.sSoyadi='';
                            this.ContactForm.sMail='',
                            this.ContactForm.sYas='',
                            this.ContactForm.sTelefon='',
                            this.ContactForm.sSehir='',
                            this.ContactForm.sPozisyon='',
                            this.ContactForm.sMaas='',
                            this.ContactForm.dteBaslamaTarihi='',
                            this.ContactForm.sWeb='',
                            this.ContactForm.sDeneyim='',
                            this.ContactForm.sUygulamalar=''

                          }
                          else{
                                console.log(response); 
                          };
                        
                        event.preventDefault();
                        
                      })
                })
                }
                      );

               
            },
        }
};
</script>
